import * as React from 'react';
import { action, observable, IObservableArray } from 'mobx';
import { observer, inject } from 'mobx-react';

// Contants
import { ROUTE_NAMES } from '../../constants/routes';

// Services
import { personAddTag, personRemoveTag } from '../../services/relation';
import { getPersonTags, IGetPersonTagsResponse } from '../../services/person';
import { getTag } from '../../services/tag';

// Types
import { IStore } from '../../store/Store';
export type ITagQuery = ITaxonomyTag;
export type ITag = IGetPersonTagsResponse;
export type IParentTag = ITaxonomyTag;

// Components
import Box from '../../components/Box';
import Container from '../../components/Container';
import { FixedTopBar } from '../../components/Layout';
import TagBar from '../../components/TagBar';
import { CircularProgress } from '../../components/Progress';
import TaxonomyCanvas, { ITaxonomyTag } from '../../components/TaxonomyCanvas';

import PeopleToolbar from './PeopleToobar';
import Router from './Router';

// Component
interface IProps {
  store?: IStore;
}

class AppNetworkPeople extends React.Component<IProps> {
  taxonomyRef: TaxonomyCanvas;
  @observable.shallow tagQuery: ITaxonomyTag[] = [];

  @observable parentTag: { tagId: string } = { tagId: '0' };

  @observable.shallow tags: ITag[] | null = null;

  componentDidMount() {
    this.props.store!.networkStore.getTaxonomy();
  }

  handleTaxonomyRef = (ref: TaxonomyCanvas) => {
    this.taxonomyRef = ref;
  };

  currentRouteResolver = (route: string) => {
    const currentRouteName = this.props.store!.routerStore.route.name;
    const segment = currentRouteName.split('.')[3];

    if (!segment) {
      return route === ROUTE_NAMES.APP_NETWORK_PEOPLE_SEARCH;
    }

    if (segment === route) {
      return true;
    }

    return false;
  };

  @action
  handleTaxonomyTitleClick = async (tag: ITaxonomyTag) => {
    if (this.currentRouteResolver(ROUTE_NAMES.APP_NETWORK_PEOPLE_SEARCH)) {
      if (
        !this.tagQuery.find((item: ITaxonomyTag) => item.tagId === tag.tagId)
      ) {
        this.tagQuery.push(tag);
      }
    }

    if (this.currentRouteResolver(ROUTE_NAMES.APP_NETWORK_PEOPLE_STATISTICS)) {
      if (
        !this.tagQuery.find((item: ITaxonomyTag) => item.tagId === tag.tagId)
      ) {
        this.tagQuery.push(tag);
      }
    }

    if (this.currentRouteResolver(ROUTE_NAMES.APP_NETWORK_PEOPLE_MYTAGS)) {
      if (tag.tagged === true) {
        await personRemoveTag({
          params: {
            networkId: this.props.store!.networkStore.network!.networkId
          },
          query: {
            tagId: tag.tagId
          }
        });
      } else {
        await personAddTag({
          params: {
            networkId: this.props.store!.networkStore.network!.networkId
          },
          query: {
            tagId: tag.tagId
          }
        });
      }
      this.getMyTags();
      this.taxonomyRef!.editItem({
        ...tag,
        tagged: !tag.tagged
      });
    }
  };

  @action
  handleTagQueryDelete = (tag: ITaxonomyTag) => {
    (this.tagQuery as IObservableArray<ITaxonomyTag>).remove(tag);
  };

  @action
  handleTaxonomyNavigate = (tags: ITaxonomyTag[]) => {
    this.parentTag.tagId = tags[tags.length - 1].tagId;
  };

  getMyTags = async () => {
    const { networkId } = this.props.store!.networkStore.network!;
    const { userId } = this.props.store!.networkStore.person!;
    this.tags = await getPersonTags({
      params: {
        networkId
      },
      query: { userId }
    });
  };

  handleTagRemove = async (tagId: string) => {
    const { networkId } = this.props.store!.networkStore.network!;
    await personRemoveTag({
      params: {
        networkId
      },
      query: {
        tagId
      }
    });
    const tag = await getTag({
      params: {
        networkId
      },
      query: {
        tagId
      }
    });
    this.taxonomyRef!.editItem({
      tagId,
      name: tag.name,
      heading: tag.heading,
      description: tag.description,
      tagged: false
    });
    this.getMyTags();
  };

  handleTabBarNavigate = (routeName: string) => {
    const networkId = this.props.store!.networkStore.network!.networkId;
    this.props.store!.routerStore.navigate(routeName, { networkId });
  };

  render() {
    if (this.props.store!.networkStore.taxonomy === null) {
      return (
        <Box pa={5} align="center">
          <CircularProgress />
        </Box>
      );
    }
    const currentRouteName = this.props.store!.routerStore.route.name;
    return (
      <div>
        <FixedTopBar size="lg" horizontalPadded={true} placement="top">
          <PeopleToolbar
            currentRouteName={currentRouteName}
            onNavigate={this.handleTabBarNavigate}
          />
        </FixedTopBar>
        <Container size="lg" padded={true}>
          <TagBar tags={this.tagQuery} onDelete={this.handleTagQueryDelete} />
        </Container>
        <TaxonomyCanvas
          ref={this.handleTaxonomyRef}
          taxonomyData={this.props.store!.networkStore.taxonomy}
          onTitleClick={this.handleTaxonomyTitleClick}
          onNavigate={this.handleTaxonomyNavigate}
          headings={true}
        />
        <Router
          tagQuery={this.tagQuery}
          parentTag={this.parentTag}
          getTags={this.getMyTags}
          tags={this.tags}
          onTagRemove={this.handleTagRemove}
        />
      </div>
    );
  }
}

export default inject('store')(observer(AppNetworkPeople));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeople/AppNetworkPeople.tsx